<template>
    <div class='ad-item'>
        <v-card class='d-flex flex-column' outlined>
            <div class='ad-card'>
                <v-carousel
                    class='ad-image'
                    v-if='item.refer.photos && item.refer.photos.length > 1'
                    cycle
                    hide-delimiters
                    prev-icon='mdi-arrow-left'
                    next-icon='mdi-arrow-right'
                    height='200'
                    hide-delimiter-background
                    show-arrows-on-hover
                >
                    <v-carousel-item
                        v-for='(slide, i) in item.refer.photos' :key='i'
                        :src='`${public_url}/${slide}`'
                    />
                </v-carousel>
                <v-img
                    v-else-if='item.refer.photos && item.refer.photos.length ===1'
                    class=' ad-image'
                    color='grey'
                    :src='`${public_url}/${item.refer.photos[0]}`'
                    :alt='item.refer.title'
                >
                    <template v-slot:placeholder>
                        <v-skeleton-loader type='card-avatar'/>
                    </template>
                </v-img>
                <v-img v-else>
                    <v-avatar
                        style='width: 100%; height: 200px'
                        color='grey'
                        class=' ad-image'
                        tile
                    >
                        عکسی برای آگهی ثبت نشده
                    </v-avatar>
                </v-img>
                <div style='position: absolute;top:0;'
                     class='pt-3'>
                    <v-chip class='mr-2' x-small>{{ translate.type[item.type] }}</v-chip>
                    <v-chip class='mr-2' color="orange" :text-color="$vuetify.theme.dark ? 'white':'black'"
                            v-if='item.special' x-small>ویژه
                    </v-chip>
                    <v-chip class='mr-2' color="red"
                            v-if='item.instant' x-small>فوری
                    </v-chip>
                    <v-chip class='mr-2' color="blue"
                            v-if='item.license' x-small>کارشناسی شده
                    </v-chip>
                </div>
            </div>
            <v-card-title class='subtitle-1 align-start'>
                <div style='width: 100%'>
                    <h4>
                        {{ translate.realEstatesType[item.refer.type] }}&nbsp;{{ item.refer.area }}متری
                    </h4>
                    <h5 v-if='item.refer.province' class="text-break">
                        استان {{ item.refer.province.title }} / شهر {{
                            item.refer.city.title
                        }} محله {{ item.refer.district }}
                    </h5>
                    <div>
                        <div v-if='item.type!=="SALE"' class="d-flex">
                            <div class="text--secondary">ودیعه:</div>
                            <v-spacer></v-spacer>
                            <div v-if='item.deposit'>{{ item.deposit.toLocaleString() + ' تومان' }}</div>
                            <div v-else>توافقی</div>
                        </div>
                        <div v-if='item.type!=="SALE"' class="d-flex">
                            <div class="text--secondary">اجاره:</div>
                            <v-spacer></v-spacer>
                            <div v-if='item.rent'>{{ item.rent.toLocaleString() + ' تومان' }}</div>
                            <div v-else>توافقی</div>
                        </div>
                        <div v-if='item.type==="SALE"' class="d-flex">
                            <div class="text--secondary">قیمت کل:</div>
                            <v-spacer></v-spacer>
                            <div v-if='item.totalAmount'>{{ item.totalAmount.toLocaleString() + ' تومان' }}</div>
                            <div v-else>توافقی</div>
                        </div>
                    </div>
                </div>
            </v-card-title>
            <v-divider/>
            <v-card-actions>
                <small class='font-weight-bold'>
                    <time :datetime='item.approved_at' v-if='item.approved_at'>
                        {{ moment(item.approved_at).format('HH:mm - jYYYY/jMM/jDD') }}
                    </time>
                    <div v-else>
                        {{ translate.status[item.status] }}
                    </div>
                </small>
                <v-spacer></v-spacer>
                <v-btn
                    small
                    outlined
                    color='primary'
                    :disabled="item.status!=='APPROVED'"
                    :to='{name:"AdDetail",  params: { ad_id: item._id }}'
                >
                    مشاهده
                </v-btn>
                <v-btn
                    v-if="item.user===user._id"
                    small
                    outlined
                    color='primary'
                    :to='{name:"MyAdDetail",  params: { ad_id: item._id }}'
                >
                    تنظیمات
                </v-btn>
            </v-card-actions>
        </v-card>
        <book-mark-ad class="star-btn" :ad="item"  :real-estate="item.refer"/>

        <div
            :id='item._id'
            v-intersect.once='{  handler: intersect,options: {delay:1000,threshold: 0.5}}'
        />
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import axios from 'axios';
import BookMarkAd from "@/components/Explore/BookMarkAd";

export default {
    name: 'AdItem',
    components: {
        BookMarkAd
    },
    props: {
        item: Object
    },
    data() {
        return {};
    },
    methods: {
        intersect() {
            axios.post(`/api/ads/${this.item._id}/insight`).catch();
        },
        localDate(item) {
            const options = {
                localeMatcher: 'lookup',
                formatMatcher: 'basic',
                year: 'numeric',
                month: 'long',
                day: '2-digit'
            };
            return new Date(item).toLocaleDateString('fa-IR', options);
        },

    },
    computed: {
        ...mapState({
            public_url: state => state.public_url,
            translate: state => state.translate.fa.ads,
            user: state => state.user
        })
    }
};
</script>

<style scoped lang='scss'>
.ad-item {
    position: relative;

    .ad-card {
        position: relative !important;
        min-height: 200px;
        max-height: 200px;
        padding: 8px;

    }

    .price {
        bottom: 0;
        left: 0;
        font-size: 20px;
        position: absolute !important;
    }

    .special_ad {
        bottom: 0;
        right: 0;
        border-radius: 8px 0 0 8px !important;
        position: absolute !important;
    }

    .star-btn {
        top: 10px;
        left: 0;
        position: absolute !important;
    }

    .ad-image {
        height: 200px;
        width: 100%;
        border-radius: 8px !important;
        filter: brightness(80%);
    }

    .ad-image:hover {
        filter: brightness(70%);
    }

    .v-card:hover {
        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    }

    :deep().v-window__next {
        z-index: 2;

        .v-btn {
            .v-btn__content {
                .v-icon {
                    font-size: 24px !important;
                }

            }
        }
    }

    :deep().v-window__prev {
        z-index: 2;

        .v-btn {
            .v-btn__content {
                .v-icon {
                    font-size: 24px !important;
                }

            }
        }
    }
}
</style>